import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Carousel from 'nuka-carousel';
import { media } from 'styled-bootstrap-grid';

import { ChevronDownIcon } from '@root/styles/icons';

export const StyledSlider = styled.div`
  padding: 0 30px;
  text-align: center;

  ${media.xl`
    margin-left: 0;
    margin-right: 0;

    .slider-control-centerright,
    .slider-control-centerleft {
      display: none;
    }
  `};

  .slider-frame {
    min-height: 65px;
  }

  .slider-control-centerright {
    right: -30px !important;
  }
  .slider-control-centerleft {
    left: -30px !important;
  }
`;

export const StyledNextButton = styled.button`
  border: 0;
  padding: 0;
  cursor: pointer;
  outline: 0;
  background: #e2e2e2;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  -webkit-tap-highlight-color: transparent;

  svg {
    width: 30px;
    transform: rotate(-90deg);
  }
`;

const StyledPrevButton = styled(StyledNextButton)`
  svg {
    transform: rotate(90deg);
  }
`;

export const NavButton = ({
  isNext = false,
  nextSlide,
  previousSlide,
  slideCount,
  slidesToScroll,
  currentSlide,
  slidesToShow,
}) => {
  const StyledComponent = isNext ? StyledNextButton : StyledPrevButton;
  if (slideCount <= slidesToScroll) {
    return null;
  }
  const isNextDisabled = isNext && currentSlide + slidesToShow >= slideCount;

  const isPreviousDisabled = !isNext && currentSlide <= 0;
  return (
    <StyledComponent
      onClick={isNext ? nextSlide : previousSlide}
      disabled={isNextDisabled || isPreviousDisabled}
      aria-label={`${currentSlide} / ${slideCount}`}
      type="button"
    >
      <ChevronDownIcon />
    </StyledComponent>
  );
};

NavButton.propTypes = {
  slideCount: PropTypes.number.isRequired,
  slidesToScroll: PropTypes.number.isRequired,
  isNext: PropTypes.bool,
  nextSlide: PropTypes.func.isRequired,
  previousSlide: PropTypes.func.isRequired,
  currentSlide: PropTypes.number.isRequired,
  slidesToShow: PropTypes.number.isRequired,
};

const Slider = ({ children, slidesToShow = 3, ...props }) => (
  <StyledSlider>
    <Carousel
      slidesToShow={slidesToShow}
      renderCenterLeftControls={(props) => <NavButton {...props} />}
      renderCenterRightControls={(props) => <NavButton {...props} isNext />}
      renderBottomCenterControls={null}
      slidesToScroll={1}
      easing="easeCubic"
      edgeEasing="easeCubic"
      cellSpacing={5}
      {...props}
    >
      {children}
    </Carousel>
  </StyledSlider>
);

Slider.propTypes = {
  slidesToScroll: PropTypes.number.isRequired,
  slidesToShow: PropTypes.number,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

export default Slider;
